/*
 * Copyright (c) 2018 Bruce Schubert.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse } from 'reactstrap';

export default class NavBar extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        iconPath: PropTypes.string,
        items: PropTypes.array,
        search: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.toggleOpen = this.toggleOpen.bind(this);
        this.close = this.close.bind(this);
    }

    toggleOpen() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    close() {
        this.setState({
            isOpen: false,
        });
    }

    render() {
        return (
          <Navbar dark color='dark' fixed='top' expand='xs'>
            <NavbarBrand>
                <img src={this.props.logo} width='32' height='32' className='d-inline-block align-top' alt=''/>
                {this.props.title}
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleOpen} />
            <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className='mr-auto' navbar>
                    {this.props.items}
                </Nav>
                <Nav className='ml-auto' navbar>
                    {this.props.search}
                </Nav>
            </Collapse>
          </Navbar>
        );
    }
}
